import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material/';
import { ContextProvider } from './hooks/useStateContext';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './components/office365auth/authConfig';
import 'bootstrap/dist/css/bootstrap.min.css';

import {  performConfigRequest } from './api/config';

const darkTheme = createTheme({
    palette: {
        mode: 'light',
    },
    typography: {
        fontFamily: '"IBM Plex Sans"'
    }
})

performConfigRequest().then(() => {
    const msalInstance = new PublicClientApplication(msalConfig());

    ReactDOM.render(
        <React.StrictMode>
            {/*<ContextProvider>*/}
                <ThemeProvider theme={darkTheme}>
                    <CssBaseline />
                    <MsalProvider instance={msalInstance}>
                        <App />
                    </MsalProvider>
                </ThemeProvider>
            {/*</ContextProvider>*/}
        </React.StrictMode>,
        document.getElementById('root')
    );
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
